module.exports = __webpack_public_path__ + "img/activity-01.c6726417.jpg";